import { gql } from "@apollo/client";

/**
 * The whole family page in one round trip. Every mutation below returns the same
 * shape, so the screen never re-asks and never renders a member list one change
 * behind the button that changed it.
 */
export const FAMILY_FIELDS = gql`
  fragment FamilyFields on Family {
    id
    name
    ownerId
    isOwner
    canSendEmail
    guardians {
      id
      name
      email
      role
    }
    learners {
      id
      name
      grade
    }
    invitations {
      id
      email
      expiresAt
      createdAt
      invitedByName
    }
  }
`;

export const GET_MY_FAMILY = gql`
  query GetMyFamily {
    myFamily {
      ...FamilyFields
    }
  }
  ${FAMILY_FIELDS}
`;

/**
 * What the person holding an invitation link is told before they sign in.
 * Unauthenticated: the whole point is that it is opened by somebody who may not
 * have an account here yet.
 */
export const GET_FAMILY_INVITATION = gql`
  query GetFamilyInvitation($token: String!) {
    familyInvitation(token: $token) {
      familyName
      invitedByName
      email
      expiresAt
      open
      refusal
    }
  }
`;
